import { useMutation, useQueryClient } from '@tanstack/react-query'
import Button from '../../../../../components/Button'
import { updateTrainingStatus } from '../../../../../services/Training'
import Loader from '../../../../../components/Loader'
import Toast from '../../../../../components/Toast/Toast'
import { useGetProfileUserInfo } from '../../../../../hooks/useGetProfileUserInfo'
import useResize from '../../../../../hooks/useResize'
import { VIEWPORT_LG } from '../../../../../utils/constants'

const SignUpNow = () => {
  const queryClient = useQueryClient()
  const viewportSize = useResize()
  const isMobile = viewportSize[0] <= VIEWPORT_LG

  const { data: userData = {}, isLoading: userDataIsLoading } =
    useGetProfileUserInfo()

  const { userInfo = {} } = userData

  const {
    mutate: updateTrainingStatusMutate,
    isLoading: isLoadingUpdateTrainingStatus,
  } = useMutation(['update-training-status'], updateTrainingStatus, {
    onSuccess: ({ status }) => {
      if (status !== 200) {
        Toast({ icon: 'error', title: 'Error en el sistema' })
      } else {
        queryClient.invalidateQueries('update-training-status')
        Toast({ title: 'Te apuntaste con éxito al programa Hutrit Next' })
      }
    },
  })

  const alreadyRegisterView = (
    <div
      className="w-100 gap-2 position-fixed d-flex align-items-center justify-content-center px-5 py-4 shadow bg-on-bg-Tertiary-hover"
      style={{
        bottom: 0,
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
      >
        <mask
          id="mask0_271_835"
          style={{
            maskType: 'alpha',
          }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="32"
          height="32"
        >
          <rect width="32" height="32" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_271_835)">
          <path
            d="M11.4668 30L8.9335 25.7333L4.1335 24.6667L4.60016 19.7333L1.3335 16L4.60016 12.2667L4.1335 7.33333L8.9335 6.26667L11.4668 2L16.0002 3.93333L20.5335 2L23.0668 6.26667L27.8668 7.33333L27.4002 12.2667L30.6668 16L27.4002 19.7333L27.8668 24.6667L23.0668 25.7333L20.5335 30L16.0002 28.0667L11.4668 30ZM12.6002 26.6L16.0002 25.1333L19.4668 26.6L21.3335 23.4L25.0002 22.5333L24.6668 18.8L27.1335 16L24.6668 13.1333L25.0002 9.4L21.3335 8.6L19.4002 5.4L16.0002 6.86667L12.5335 5.4L10.6668 8.6L7.00016 9.4L7.3335 13.1333L4.86683 16L7.3335 18.8L7.00016 22.6L10.6668 23.4L12.6002 26.6ZM14.6002 20.7333L22.1335 13.2L20.2668 11.2667L14.6002 16.9333L11.7335 14.1333L9.86683 16L14.6002 20.7333Z"
            fill="#01A76A"
          />
        </g>
      </svg>
      <span
        style={{
          color: '#01A76A',
        }}
      >
        ¡Ya formas parte del programa Hutrit Next!
      </span>
    </div>
  )

  const waitingAnswer = (
    <div
      className="w-100 position-fixed d-flex align-items-center justify-content-between px-5 py-4 shadow bg-white"
      style={{
        bottom: 0,
      }}
    >
      <div className="d-flex align-items-center gap-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <mask
            id="mask0_251_575"
            style={{
              maskType: 'alpha',
            }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="32"
            height="32"
          >
            <rect width="32" height="32" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_251_575)">
            <path
              d="M4.00016 26.6667C3.26683 26.6667 2.63905 26.4056 2.11683 25.8833C1.59461 25.3611 1.3335 24.7333 1.3335 24C1.3335 23.2667 1.59461 22.6389 2.11683 22.1167C2.63905 21.5944 3.26683 21.3333 4.00016 21.3333H4.35016C4.45016 21.3333 4.55572 21.3556 4.66683 21.4L10.7335 15.3333C10.6891 15.2222 10.6668 15.1167 10.6668 15.0167V14.6667C10.6668 13.9333 10.9279 13.3056 11.4502 12.7833C11.9724 12.2611 12.6002 12 13.3335 12C14.0668 12 14.6946 12.2611 15.2168 12.7833C15.7391 13.3056 16.0002 13.9333 16.0002 14.6667C16.0002 14.7111 15.9779 14.9333 15.9335 15.3333L19.3335 18.7333C19.4446 18.6889 19.5502 18.6667 19.6502 18.6667H20.3502C20.4502 18.6667 20.5557 18.6889 20.6668 18.7333L25.4002 14C25.3557 13.8889 25.3335 13.7833 25.3335 13.6833V13.3333C25.3335 12.6 25.5946 11.9722 26.1168 11.45C26.639 10.9278 27.2668 10.6667 28.0002 10.6667C28.7335 10.6667 29.3613 10.9278 29.8835 11.45C30.4057 11.9722 30.6668 12.6 30.6668 13.3333C30.6668 14.0667 30.4057 14.6944 29.8835 15.2167C29.3613 15.7389 28.7335 16 28.0002 16H27.6502C27.5502 16 27.4446 15.9778 27.3335 15.9333L22.6002 20.6667C22.6446 20.7778 22.6668 20.8833 22.6668 20.9833V21.3333C22.6668 22.0667 22.4057 22.6944 21.8835 23.2167C21.3613 23.7389 20.7335 24 20.0002 24C19.2668 24 18.6391 23.7389 18.1168 23.2167C17.5946 22.6944 17.3335 22.0667 17.3335 21.3333V20.9833C17.3335 20.8833 17.3557 20.7778 17.4002 20.6667L14.0002 17.2667C13.8891 17.3111 13.7835 17.3333 13.6835 17.3333H13.3335C13.2891 17.3333 13.0668 17.3111 12.6668 17.2667L6.60016 23.3333C6.64461 23.4444 6.66683 23.55 6.66683 23.65V24C6.66683 24.7333 6.40572 25.3611 5.8835 25.8833C5.36127 26.4056 4.7335 26.6667 4.00016 26.6667ZM5.3335 13.3L4.50016 11.5L2.70016 10.6667L4.50016 9.83333L5.3335 8.03333L6.16683 9.83333L7.96683 10.6667L6.16683 11.5L5.3335 13.3ZM20.0002 12L18.7335 9.26667L16.0002 8L18.7335 6.73333L20.0002 4L21.2668 6.73333L24.0002 8L21.2668 9.26667L20.0002 12Z"
              fill="#01A76A"
            />
          </g>
        </svg>
        <span
          className="text-on-bg-primary"
          style={{
            fontSize: isMobile ? '10px' : '16px',
          }}
        >
          Apúntate ahora y comienza tus prácticas profesionales pagas
        </span>
      </div>
      <Button onClick={() => updateTrainingStatusMutate({ state: true })}>
        {isLoadingUpdateTrainingStatus ? (
          <Loader />
        ) : (
          <span
            style={{
              fontSize: isMobile ? '10px' : '16px',
            }}
          >
            {isMobile ? 'Quiero apuntarme' : 'Quiero apuntarme al programa'}
          </span>
        )}
      </Button>
    </div>
  )

  if (userDataIsLoading) return <Loader />

  return userInfo?.training ? alreadyRegisterView : waitingAnswer
}

export default SignUpNow
